import Widget from "./base.js";

export class FooterMenu extends Widget {
	componentWillMount() {
		this.state.open = false;
		this.toggle = this.toggle.bind(this);
	}

	componentDidMount() {
		this.bodyEventListener();
	}

	componentDidUpdate() {}

	toggle() {
		this.setState({ open: !this.state.open });
	}

	bodyEventListener() {
		const self = this;
		document.body.addEventListener(
			"click",
			(event) => {
				if (event.target.closest(".FooterMenu")) return;
				self.setState({ open: false });
			},
			true
		);
	}

	renderContent() {
		return (
			<div>
				<div onClick={this.toggle} className="FooterMenu__Toggle">
					<i class="fa-regular fa-ellipsis"></i>
				</div>

				{this.state.open && (
					<div className="FooterMenu__Menu">
						<ul class="FooterMenu__List">
							<li class="FooterMenu__ListItem">
								<a href="/about">About</a>
							</li>
							<li class="FooterMenu__ListItem">
								<a href="/memberships">Memberships</a>
							</li>
							<li class="FooterMenu__ListItem">
								<a href="/newsletters">Newsletters</a>
							</li>
							<li class="FooterMenu__ListItem">
								<a href="/faq">FAQ</a>
							</li>
							<li class="FooterMenu__ListItem">
								<a href="/careers">Careers</a>
							</li>
							<li class="FooterMenu__ListItem">
								<a href="/pitch-us">Pitch Us</a>
							</li>
							<li class="FooterMenu__ListItem">
								<a
									href="https://s3.amazonaws.com/tpm-media/2021-ad-offerings-site_compressed.pdf"
									target="_blank"
									rel="noopener"
								>
									Advertise
								</a>
							</li>
							<li class="FooterMenu__ListItem">
								<a
									href="http://status.talkingpointsmemo.com/"
									target="_blank"
									rel="noopener"
								>
									Site Status
								</a>
							</li>
							<li class="FooterMenu__ListItem">
								<a href="/terms-of-use">Terms of Use</a>
							</li>
							<li class="FooterMenu__ListItem">
								<a href="/ccpa-notice">CCPA Notice</a>
							</li>
							<li class="FooterMenu__ListItem --mobile-only">
								<a href="/privacy">Privacy Policy</a>
							</li>
							<li class="FooterMenu__ListItem --mobile-only">
								<a href="/contact">Contact</a>
							</li>
							<li class="FooterMenu__ListItem --mobile-only">
								<a href="/about#masthead">Masthead</a>
							</li>
						</ul>

						<div className="FooterMenu__Social">
							<div class="Social Footer__Social">
								<a
									href="https://bsky.app/profile/talkingpointsmemo.com"
									title="bluesky"
									class="footer-social-bluesky"
								>
									<i class="fab fa-bluesky" aria-hidden="true"></i>
								</a>
								<a
									href="https://facebook.com/talkingpointsmemo"
									title="facebook"
									class="footer-social-facebook"
								>
									<i class="fab fa-facebook-f" aria-hidden="true"></i>
								</a>
								<a
									href="https://twitter.com/tpm"
									title="twitter"
									class="footer-social-twitter"
								>
									<i class="fab fa-x-twitter" aria-hidden="true"></i>
								</a>
								<a
									href="https://www.instagram.com/talkingpointsmemo/"
									title="instagram"
									class="footer-social-instagram"
								>
									<i class="fab fa-instagram" aria-hidden="true"></i>
								</a>
								<a
									href="https://www.youtube.com/user/tpmtv"
									title="youtube"
									class="footer-social-youtube"
								>
									<i class="fab fa-youtube" aria-hidden="true"></i>
								</a>
							</div>
						</div>
						<div className="FooterMenu__Rights">ALL RIGHTS RESERVED.</div>
					</div>
				)}
			</div>
		);
	}
}
